/**
 * PM-2229: the pharmacy-facing onboarding progress map — shared vocabulary.
 *
 * Types only, so this file is safe for `@pm/shared/core` (no React). Core owns
 * the copy and the HubSpot deal-stage mapping and serves a fully-rendered
 * `OnboardingProgress` to both frontends; the apps only ever render what they
 * are given. Keeping the labels server-side means fixing a wording problem is a
 * core deploy, not a coordinated release of two SPAs.
 */
export var OnboardingStepKey;
(function (OnboardingStepKey) {
    OnboardingStepKey["REGISTRATION"] = "registration";
    OnboardingStepKey["AGREEMENTS"] = "agreements";
    OnboardingStepKey["WHOLESALER_PMS_SETUP"] = "wholesalerPmsSetup";
    OnboardingStepKey["QUALITY_CONTROL"] = "qualityControl";
    OnboardingStepKey["ACTIVATION"] = "activation";
    OnboardingStepKey["TRAINING"] = "training";
    OnboardingStepKey["FILING_APPEALS"] = "filingAppeals";
})(OnboardingStepKey || (OnboardingStepKey = {}));
